<app-multi-max-device-customer-management *ngIf="isMultiMaxDeviceEnabled; else standardLanding"></app-multi-max-device-customer-management>
<ng-template #standardLanding>
	<app-pm-customer-management></app-pm-customer-management>
</ng-template>
